// extracted by mini-css-extract-plugin
export default {"link_container":"TFALink_link_container__LUAiG","forward":"TFALink_forward__j6DKc","backward":"TFALink_backward__8IfNo"};